import {
	Container,
	ContainerGutter,
	ContainerPadding,
	CTA,
	Divider,
	Image,
	styled,
	Text,
	TextAlignment,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import { Logo } from '@volkswagen-onehub/icons-core';
import * as React from 'react';
import { COLOR_TOKEN } from '../../../../../helpers/color-tokens';
import { HuchaIcon } from '../../assets/hucha-icon';
import { HuchaValues } from '../../models/hucha-values';
import { HuchaDisclaimer1Content } from '../disclaimers/hucha-disclaimer1-content';
import { HuchaDisclaimer2StandardContent } from '../disclaimers/hucha-disclaimer2-standard-content';
import { PdfRenovadoresBonusCard } from './pdf-card/pdf-renovadores-bonus-card/pdf-renovadores-bonus-card';

const TopContainer = styled(Container)`
	background-color: ${COLOR_TOKEN.button.primary.default};
`;

const SVGContainer = styled.div`
	& > svg {
		width: 56px;
	}
`;

const BonusDiscountContainer = styled.div`
	position: absolute;
	bottom: -10%;
	left: 50%;
	transform: translateX(-50%);
	z-index: 2;
	width: max-content;
	padding: var(--size-dynamic0020) var(--size-dynamic0050);
	background-color: ${COLOR_TOKEN.button.primary.default};
	border: 1px solid ${COLOR_TOKEN.content.inverted};
	border-radius: 16px;
`;

const RelativeContainer = styled.div`
	position: relative;
`;

const CTAStyled = styled(CTA)`
	background-color: ${COLOR_TOKEN.button.primary.default};
	width: 64px;
	height: 64px;

	& svg {
		width: 56px;
		height: 56px;
	}
`;

export const RenovadoresStandardBonusPdf: React.FC<{
	huchaValues: HuchaValues | null;
}> = ({ huchaValues }) => {
	return (
		<>
			<TopContainer stretchContent>
				<Container padding={ContainerPadding.dynamic0100} verticalAlign={'center'}>
					<SVGContainer className="svg-container">
						<CTAStyled tag="button" emphasis="primary" icon={<Logo variant="default" />} />
					</SVGContainer>
				</Container>
				<Container
					horizontalAlign={'flex-end'}
					verticalAlign={'center'}
					padding={ContainerPadding.dynamic0100}
					gutter={ContainerGutter.static250}
				>
					<SVGContainer className="svg-container">
						<HuchaIcon />
					</SVGContainer>
					<Container wrap={'always'} horizontalAlign={'center'} verticalAlign={'center'}>
						<Text appearance={TokenTextAppearance.headline200} color={TokenTextColor.inverted} bold>
							Hucha{' '}
						</Text>
						<Text appearance={TokenTextAppearance.headline200} color={TokenTextColor.inverted}>
							Volkswagen
						</Text>
					</Container>
				</Container>
			</TopContainer>

			<Container
				padding={{
					top: ContainerPadding.static400,
					bottom: ContainerPadding.static500,
					left: ContainerPadding.static400,
					right: ContainerPadding.static400,
				}}
				stretchContent
			>
				<RelativeContainer>
					<Image
						src="https://vgedonehubappsstaweupro.blob.core.windows.net/storage/images-portal/img_pdf_renovadores_small.png"
						alt="Imagen descuentos renovadores Volkswagen"
						style={{ borderRadius: '16px', objectFit: 'cover' }}
					/>
					<BonusDiscountContainer className="bonus-discount__container">
						<Container horizontalAlign={'center'} verticalAlign={'center'} padding={ContainerPadding.static250}>
							<Text
								appearance={TokenTextAppearance.headline300}
								color={TokenTextColor.inverted}
								textAlign={TextAlignment.center}
								bold
							>
								{huchaValues?.idUser}
							</Text>
						</Container>
					</BonusDiscountContainer>
				</RelativeContainer>
			</Container>

			<Container
				padding={{
					top: ContainerPadding.static250,
					left: ContainerPadding.static400,
					right: ContainerPadding.static400,
				}}
				stretchContent
			>
				<PdfRenovadoresBonusCard dineroHucha={huchaValues?.dineroHucha ?? ''} />
			</Container>

			<Container
				padding={{
					right: ContainerPadding.static400,
					left: ContainerPadding.static400,
				}}
				horizontalAlign={'center'}
				wrap={'always'}
			>
				<Container wrap={'always'}>
					<Container
						wrap={'always'}
						padding={{
							top: ContainerPadding.static300,
						}}
						gutter={ContainerGutter.static150}
					>
						<Divider />

						<Text appearance={TokenTextAppearance.headline200} textAlign={TextAlignment.center}>
							Nombre:{' '}
							<Text bold>{huchaValues?.name + ' ' + huchaValues?.apellido1 + ' ' + huchaValues?.apellido2}</Text>
						</Text>

						<Text appearance={TokenTextAppearance.headline200} textAlign={TextAlignment.center}>
							E-mail: <Text bold>{huchaValues?.email}</Text>
						</Text>

						<Text appearance={TokenTextAppearance.headline200} textAlign={TextAlignment.center}>
							Hucha Club Volkswagen<Text sup>1</Text>: <Text bold>{huchaValues?.dineroHucha}€</Text>
						</Text>

						<Text appearance={TokenTextAppearance.headline200} textAlign={TextAlignment.center}>
							Campaña lealtad para matrículas 2011-2016<Text sup>2</Text>:{' '}
							<Text bold>{huchaValues?.dineroRenovadores}€</Text>
						</Text>

						<Text appearance={TokenTextAppearance.headline200} textAlign={TextAlignment.center}>
							Descuento total: <Text bold>{huchaValues?.descuentoTotal}€</Text>
						</Text>

						<Text appearance={TokenTextAppearance.headline200} textAlign={TextAlignment.center}>
							Fecha de descarga: <Text bold>{huchaValues?.fechaDescarga}</Text>
						</Text>

						<Divider />
					</Container>

					<Container
						wrap={'always'}
						padding={{
							top: ContainerPadding.static300,
						}}
						verticalAlign={'center'}
						horizontalAlign={'center'}
					>
						<Text appearance={TokenTextAppearance.copy200} textAlign={TextAlignment.center} bold>
							Este bono contiene la suma total de tu ahorro acumulado.
						</Text>
						<Text appearance={TokenTextAppearance.copy200} textAlign={TextAlignment.center} bold>
							Es intransferible y está sujeto a las condiciones que se especifican a continuación.
						</Text>
					</Container>

					<Container
						wrap={'always'}
						padding={{
							top: ContainerPadding.static300,
						}}
						verticalAlign={'center'}
						horizontalAlign={'center'}
						gutter={ContainerGutter.static200}
					>
						<HuchaDisclaimer1Content fontSize="13px" textGutter={ContainerGutter.static200} />
						<HuchaDisclaimer2StandardContent fontSize="13px" textGutter={ContainerGutter.static200} />
					</Container>
				</Container>
			</Container>
		</>
	);
};
